module.exports = __webpack_public_path__ + "img/br.78184038.svg";